import { Component } from 'react';

class SectionCont5 extends Component {
	render() {
		return (
			<section id="" className="sub-content cont5">
				<div className="sub-inner">
					<div className="title-group">
						<strong className="title">타사ERP의 Pain Point와 Stella 의 해결방안</strong>
						<p className="desc">
							타사ERP가 비용 증가와 경영 가시성 한계로 성장의 걸림돌이 되는 반면,
							<br />
							Stella는 <b>단일 요금 기반의 통합 구조</b>로 비용을 통제하고 실시간 경영 · 자금 관리를 가능하게 합니다.
						</p>
					</div>
					<div className="diff-box type1">
						<div className="diff-item">
							<p className="title">타사 ERP : 고비용/저효율</p>
							<ul className="diff-list">
								<li>
									<p>전자결재 별도과금</p>
									<span>사용자당 월2천원(예시)추가</span>
								</li>
								<li>
									<p>실시간 경영 리포트 부재</p>
									<span>보고서 수동 생성 3~5일 소요</span>
								</li>
								<li>
									<p>재고 · 영업 관리 기능 미제공 </p>
									<span>별도 엑셀 관리로 데이터 파편화</span>
								</li>
								<li>
									<p>인원 증가 시 비용 급증</p>
									<span>사용자당 월 3만원(예시) 과금 방식</span>
								</li>
								<li>
									<p>데이터 분산 및 재설명 부담</p>
									<span>외부 전문가 대응 시 수동 작업</span>
								</li>
							</ul>
						</div>
						<div className="diff-item type2">
							<p className="title">스텔라 ERP : 저비용/고효율</p>
							<ul className="diff-list">
								<li>
									<p>전자결재 기본 포함</p>
									<span>추가비용 0원</span>
								</li>
								<li>
									<p>경영보고서 실시간 KPI 대시보드</p>
									<span>즉시 의사결정 지원</span>
								</li>
								<li>
									<p>통합 재고 · 영업 관리 시스템</p>
									<span>견적부터 채권까지 일원화</span>
								</li>
								<li>
									<p>사용자 무제한 단일 요금제</p>
									<span>월 7만원 고정(추가비용 0원)</span>
								</li>
								<li>
									<p>결재=회계=자금 일체화 시스템</p>
									<span>회계법인 전문가 직접 연계</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default SectionCont5;
